module.exports = __webpack_public_path__ + "bd45c85e13886a5483fe9a8dc8a87ef3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-31.png
// module id = 3157
// module chunks = 0